import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "4.5 2 15 19",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" })
});
export default SvgNavigation;
